
define('text!components/RadialProgress/RadialProgressView.stache',[],function () { return '<div class="circle">\r\n\t<div class="mask full">\r\n\t\t<div class="fill"></div>\r\n\t</div>\r\n\t<div class="mask half">\r\n\t\t<div class="fill"></div>\r\n\t\t<div class="fill fix"></div>\r\n\t</div>\r\n</div>\r\n<div class="inset">\r\n\t<div class="text">{{text}}</div>\r\n</div>';});

